'use client'
import Script from "next/script"

const LocalBusinessLdJson = ({}) => {

    let jsonLd = {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "WebSite",
                "name": "RE/MAX Island Real Estate",
                "description": "We are a full-service real estate company offering comprehensive services in Koh Samui. Our result-oriented approach provides our clients with optimal solutions.",
                "url": "https://buysamui.com"
            },
            {
                "@type": "Organization",
                "name": "RE/MAX Island Real Estate",
                "url": "https://buysamui.com",
                "logo": "https://buysamui.com/images/author.png",
                "sameAs": [
                    "https://www.facebook.com/remaxsamui",
                    "https://www.linkedin.com/company/remax-island-real-estate",
                    "https://www.instagram.com/remaxsamui",
                    "https://www.tiktok.com/@remaxsamui",
                    "https://www.youtube.com/@remaxislandrealestate8644"

                ]
            },
            {
            "@type": ["LocalBusiness", "RealEstateAgency"],
                "name": "RE/MAX Island Real Estate",
                "url": "https://buysamui.com",
                "image": "https://buysamui.com/images/share.jpg",
                "telephone": "+66800410420",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "1/39 Moo 6, Bophut",
                    "addressLocality": "Koh Samui",
                    "addressRegion": "Surat Thani",
                    "postalCode": "84320",
                    "addressCountry": "TH"
                },
                "openingHours":["Mo-Fr 09:00-18:00"],
                "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": "5",
                    "reviewCount": "47"
                }
            }
        ]
    }

         
    return (
        <Script
            strategy="beforeInteractive"
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
            key="website-jsonld"
        />
    )
}

export default LocalBusinessLdJson